/**
 * Service worker registration.
 * - Only in production builds (dev mode would cache stale bundles).
 * - Auto-checks for a new SW every 60 minutes.
 * - Emits `gg:sw-updated` on the window when a new worker is waiting so a
 *   toast/banner can prompt the user to refresh.
 */
export function registerServiceWorker() {
    if (typeof window === "undefined") return;
    if (!("serviceWorker" in navigator)) return;
    if (process.env.NODE_ENV !== "production") return;

    window.addEventListener("load", async () => {
        try {
            const reg = await navigator.serviceWorker.register("/service-worker.js", { scope: "/" });

            // Periodic update check (every hour while tab is open)
            setInterval(() => reg.update().catch(() => null), 60 * 60 * 1000);

            reg.addEventListener("updatefound", () => {
                const nw = reg.installing;
                if (!nw) return;
                nw.addEventListener("statechange", () => {
                    if (nw.state === "installed" && navigator.serviceWorker.controller) {
                        // A new SW is waiting — notify the app.
                        window.dispatchEvent(new CustomEvent("gg:sw-updated", { detail: { registration: reg } }));
                    }
                });
            });
        } catch (e) {
            // Swallow — offline still works via subsequent visits.
            console.warn("[SW] registration failed", e);
        }
    });
}

/** Ask the waiting worker to activate immediately. */
export function activateWaitingWorker() {
    if (!("serviceWorker" in navigator)) return;
    navigator.serviceWorker.getRegistration().then((reg) => {
        if (reg && reg.waiting) reg.waiting.postMessage({ type: "SKIP_WAITING" });
    });
}
